import { CloudFrameStack } from "@cloudframe/stack";
import Authorization from "../components/auth/authorization";
import { UserPermission } from "../constants/permissions.constants";
import GenerateActivationKey from "../components/activationkey-cn/generateactivationkey";

const CreateActivationKey = () => {
  return (
    <Authorization>
      <section key={UserPermission.P_ACTIVATION_KEY_CN}>
        <div style={{ margin: 16 }}>
          <CloudFrameStack>
            <GenerateActivationKey />
          </CloudFrameStack>
        </div>
      </section>
    </Authorization>
  );
};

export default CreateActivationKey;
